<template>
  <v-form ref="form" :readonly="readonly">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field 
          v-model="economic_group.name" 
          label="Nome do Grupo Econômico" 
          prepend-icon="mdi-form-textbox" 
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import validations from '@/mixins/validations.js'

export default {
  name: 'EconomicGroupForm',
  mixins: [validations],
  props: {
    economic_group: {
      required: true,
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      rules: {
        required: v => !!v || 'Obrigatório',
      }
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
  },
}
</script>

